// extracted by mini-css-extract-plugin
export var changeIcon = "_4k-4";
export var container = "_4k-0";
export var divider = "_4k-7";
export var externalLinkIcon = "_4k-1";
export var green = "_4k-5";
export var helpCircleIcon = "_4k-3";
export var iconButton = "_4k-2";
export var red = "_4k-6";